import { action, observable, toJS } from 'mobx';
import VendortTemplateAPI from '../services/generator-vendor-template-service';
import { AppConstants, Types } from '../../../common/APIConstants';
import moment from 'moment';
import _ from 'lodash';
import RestEndPoint from '../../../common/RestEndPoint';
class VendortTemplateDataStore {
  @observable screenRowData = {
    VendorData: []
  };
  @observable screenColumnDefinitions = {
       GeneratorVendorTemplate:[]
  };
  @observable headerDetails = {
    monthDpDwnList: [],
    vendorDpDwnList:[] 
  };
  @observable hasScreenData = false;

  getHeaderData = async (CommonStore) => {
    CommonStore.toggleLoader();
    try {

    const { data } = await VendortTemplateAPI.getHeaderData();
    var test= data.calendors;
    this.headerDetails.monthDpDwnList= data.calendors; 
    this.headerDetails.vendorDpDwnList= data.vendors; 
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
  }
}
saveScreenData = async (currentScreenChildren, CommonStore) => {
  CommonStore.toggleLoader();
  let rowData= this.screenRowData.VendorData.map(v => ({...v, IsModified: v.IsModified?v.IsModified:false}));
  rowData= rowData.filter(x=>x.IsModified);
  var currentTime = moment(new Date());
  try {
    let requestObj = {
      "ScreenDetails": currentScreenChildren[0],     
      "VendorRequests":rowData,
      "UpdatedBy": RestEndPoint.getCurrentUserName(),
      "UpdatedOn":currentTime,
    };
    const { data } = await VendortTemplateAPI.updateVendorScreenData(requestObj);
    window.toastr.success("Data Saved Sucessfully!");
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
    if (error.response && error.response.data.includes("Data not available for selected date")) {
      window.toastr.error(error.response.data);
    }
    else {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  }
};

resetVendorData =() =>
{
  this.screenRowData.VendorData = [];
  this.hasScreenData = false;
}
getScreenData = async (currentScreenChildren, vendorTxt, monthTxt, CommonStore) => {
  CommonStore.toggleLoader();
  this.hasScreenData = false;
  this.screenRowData.VendorData=[];
  try {
    let requestObj = {
      "ScreenDetails": currentScreenChildren[0],
      "periodId": monthTxt,
      "vendorName": vendorTxt
    };
    const { data } = await VendortTemplateAPI.getScreenData(requestObj);
    this.screenRowData.VendorData = data;
    this.hasScreenData = true;
    CommonStore.toggleLoader();
  } catch (error) {
    CommonStore.toggleLoader();
    if (error.response && error.response.data.includes("Data not available for selected date")) {
      window.toastr.error(error.response.data);
    }
    else {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  }
};

setColumnDef = async (currentScreenChildren, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      currentScreenChildren.forEach((child) => {
        const { screen, screenColumns: columns } = child;
    this.screenColumnDefinitions[child.screen.name] = [];

    this.screenColumnDefinitions[child.screen.name] = this.getAllColumnDefinitions(screen, columns);
  });
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available for selected date")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };

  getAllColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
          gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: 'text',
        hide: column.hidden,
        width: column.width ? column.width : 200,
        keyCreator: (params) => { return this.getValueFomatter(params, column, screen) ? this.getValueFomatter(params, column, screen) : params.value },
        editable: (params) => { return this.getIsEditable(params, column, screen) },
        cellClassRules: {
          'highlight-cell': (params) => { return this.getIsEditable(params, column, screen) },
          'grid-cell-custom': (params) => { return params.data ? true : false }
        },
        cellRenderer: this.getCellRenderer(column),
        cellRendererParams: (params) => this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => { return this.getValueFomatter(params, column, screen) },
      });
     
    });
    return gridColumns;
  };
 
  getValue(params,screen, column )
  {  
   
    return params.data[column.name];
  
  }
  getIsEditable(params, column, screen) {
    
    if (this.getIsDataReadOnly() || !params.data)
      return false;

    // if (screen.name === "Production" && column.name === "TargetValue" && params.node.data.Parameter === "Upgrader Fd") {
    //   return true;
    // }
    else {
      return !column.readOnly;
    }
  }

  getIsDataReadOnly() {

    /* Uncomment any of this to disable the editing on screen for past dates OR a week before */
    
    // return moment(this.headerDetails.endDateTime).isBefore(moment(), "day");
    // return moment(this.headerDetails.endDateTime).isBefore(moment().subtract(7, "days"), "day");

    return false;
  }

  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return 'booleanCellEditor';
      case Types.DATE:
        return 'dateFormatter';
        case Types.DATETIME:
        return 'dateTimeFormatter';
       
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return 'SmartSelectClearable';
        case Types.NUMBER:
          return 'numericCellEditor';
          case Types.DECIMAL:
          return 'decimalCellEditor';
    }
  }
  getCellEditorParams(column, params) {

    switch (column.type) {
      case Types.DROPDOWN:
        return {values: column.refLookupData?.lookupValues.values, isPopup: true};
    }
  }

  getCellRendererParams(column, params) {
    switch (column.type) {
      case Types.BOOLEAN:
        return { isDisabled: this.getIsDataReadOnly() };
    }
  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(column.refLookupData.lookupValues, params.value);
      }

      // if (screen.name === "ProductSpec" && (column.name === "DailyAvgValue" || column.name === "InstantValue")) {
      //   return (params.node.data.Parameter === "C3 Treater Moisture" && params.value == "99") ? "Bypassed" : params.value;
      // }
    }
  }

  lookupValue(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value == key)) return null;
    else {
      let label = mappings.values.find(item => item.value == key).label;
      return label;
    }
  }
}

export default new VendortTemplateDataStore();